import { CARD, SECTION } from './helper';

export const VisitsSkeleton = () => (
  <>
    <div className={`${CARD} px-4 py-3`}>
      <div className="skeleton h-3 w-28" />

      <div className="flex flex-wrap gap-2 mt-3">
        {[0, 1, 2].map((chip) => (
          <div key={chip} className="skeleton h-7 w-20 rounded-full" />
        ))}
      </div>
    </div>

    <div className={`${CARD} overflow-hidden`}>
      <div className="skeleton h-32 w-full rounded-none" />

      <div className="grid grid-cols-1 sm:grid-cols-2 divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
        <div className="flex items-center gap-3 p-3.5">
          <div className="skeleton h-9 w-9 rounded-xl shrink-0" />
          <div className="w-full">
            <div className="skeleton h-3 w-24" />
            <div className="skeleton h-2.5 w-40 mt-2" />
          </div>
        </div>

        <div className="p-3.5">
          <div className="skeleton h-2.5 w-32" />
          <div className="skeleton h-3.5 w-full mt-3" />
          <div className="skeleton h-3.5 w-full mt-2" />
        </div>
      </div>
    </div>
  </>
);

export const ProfileSkeleton = () => (
  <div className={`${CARD} p-4`}>
    <div className="flex items-center gap-3 pb-3.5 border-b border-gray-100">
      <div className="skeleton h-11 w-11 rounded-full shrink-0" />
      <div className="w-full min-w-0">
        <div className="skeleton h-3 w-full max-w-32" />
        <div className="skeleton h-2.5 w-full max-w-40 mt-2" />
      </div>
    </div>

    <div className="space-y-2.5 mt-3">
      {[0, 1, 2].map((section) => (
        <div key={section} className={SECTION}>
          <div className="flex items-center gap-2.5">
            <div className="skeleton h-8 w-8 rounded-xl shrink-0" />
            <div className="skeleton h-3 w-full max-w-28" />
          </div>

          <div className="skeleton h-2.5 w-full mt-3" />
          <div className="skeleton h-2.5 w-3/4 mt-2" />
        </div>
      ))}
    </div>
  </div>
);
